import ProfileTopNavigation from './ProfileTopNavigation';
import ChangePasswordSection from '../../PageComponent/ProfilePage/ChangePasswordSection';
function ChangePassword() {
  
  return (
    <div>
        <ProfileTopNavigation pageTitle={'Change password'} />
        <ChangePasswordSection />
    </div>
  );
}

export default ChangePassword;
